import React, { useRef } from 'react';
import { Hero } from '../components/Hero';
import { QuizExperience } from '../components/QuizExperience';
import { Footer } from '../components/Footer';
interface LandingProps {
  webinarUrl: string;
  youtubeUrl: string;
  instagramUrl: string;
}
export function Landing({
  webinarUrl,
  youtubeUrl,
  instagramUrl
}: LandingProps) {
  const testRef = useRef<HTMLDivElement>(null);
  function handleStart() {
    testRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  return <div className="flex min-h-full w-full flex-col bg-hueso" data-id="element-161" data-mp="3gaoqkmgk2gj">
      <Hero onStart={handleStart} data-id="element-162" data-mp="87sr9d44qb3m" />
      <main className="flex-1" data-id="element-163" data-mp="87kdzk43h3rw">
        <div ref={testRef} data-id="element-164" data-mp="88m1io2ariqi">
          <QuizExperience webinarUrl={webinarUrl} data-id="element-165" data-mp="c9ebjjiztrnu" />
        </div>
      </main>
      <Footer youtubeUrl={youtubeUrl} instagramUrl={instagramUrl} data-id="element-166" data-mp="c8mioggs6819" />
    </div>;
}